<template>
    <div>
      <h2>Welcome, {{ username }}</h2>
      <img :src="profilePic" alt="Profile" />
      <p>{{ bio }}</p>
      <button @click="handleLogout">Logout</button>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { logout } from '../auth';
  
  export default {
    setup() {
      const router = useRouter();
      const username = ref('Usuario'); // Esto debe ser recuperado de la fuente de datos
      const bio = ref('Biografía aquí...');
      const profilePic = ref('/path/to/default/profile/pic.jpg');
  
      const handleLogout = () => {
        logout();
        router.push('/forbidden');
      };
  
      return { username, bio, profilePic, handleLogout };
    },
  };
  </script>
  